import '../../capabilities/registry';
import { registerDeployPlugin } from '../../core/registry';
import { hasFormFieldValue, registerSkuResourceModulesEnricher } from '../../platform/preset-hydration';
import { registerResourceConfigs } from '../../platform/resource-watch';
import { registerSkuModuleMeta } from '../../platform/scene-layout/moduleMetaRegistry';
import { ciHeadless } from './headless';
import { CI_RESOURCE_CONFIGS, CI_SKU_MODULE_META } from './resourceConfigs';

registerSkuModuleMeta('ContainerInstance', CI_SKU_MODULE_META);

registerSkuResourceModulesEnricher('ContainerInstance', (data, modules) => {
  const hasVolumes = hasFormFieldValue(data, 'volumes');
  if (!modules && !hasVolumes) return undefined;
  return { ...(modules ?? {}), ...(hasVolumes ? { storage: true } : {}) };
});

registerResourceConfigs('ContainerInstance', CI_RESOURCE_CONFIGS);

registerDeployPlugin({
  headless: ciHeadless,
  loadUi: () =>
    import('./ui').then((m) => ({
      ResourceEditor: m.CiResourceEditor,
      ResourcePreview: m.CiResourcePreview,
    })),
});

export { CI_FIELD_KEYS } from './fields';
export type { CiFieldKey } from './fields';
export {
  CI_SCENES,
  CI_ALL_MODULES,
  CI_SKU_MODULES,
  CI_SKU_MODULE_LIST,
  filterCiSkuModules,
  isCiSkuModuleKey,
  CI_ORDER_MODULES,
  CI_DIRECT_CREATE_STEPS,
  CI_DIRECT_MERGED_MODULES,
  filterCiDirectMergedModules,
  buildCiDirectResourceModulesFromForm,
  resolveCiSceneConfig,
} from './scenes';
export type { CiDirectCreateStep, CiDirectMergedModuleKey, CiSkuModuleKey } from './scenes';
export { CI_MODULES } from './modules';
export { CI_RESOURCE_CONFIGS, CI_SKU_MODULE_META } from './resourceConfigs';
export { resetCiSkuModuleFields } from './skuModuleReset';
export {
  buildCiFreshDisplayConfig,
  finalizeCiSubmitDisplayConfig,
  filterCiProductCardDisplayConfig,
  isCiProductCardExcludedId,
} from './display';
export { buildCiMergedDisplayConfig } from './display/mergeDisplayConfig';
export {
  resolveCiSkuPreviewExtraWatchFields,
  resolveCiOrderPreviewExtraWatchFields,
  resolveCiOrderInnerRootWatchFields,
} from './orderPreviewWatch';
export { buildContainerInstanceOrderDeliveryMetadata } from './headless/deliveryMetadata';
export type { ContainerInstanceDeliveryMetadata } from './headless/deliveryMetadata';
export { hydrateContainerInstanceDetailToForm } from './hydrateFromApiDetail';
export { confirmContainerImageOnForm } from './headless/imageConfirm';
export { buildCiSkuCapabilityOptions } from './skuCapabilityOptions';
export { CiResourceEditor, CiResourcePreview, useCiDeployFormLinkage } from './ui';
export type { CiResourceEditorProps } from './ui';
export type { CiLinkagePropsMap } from './linkage';
